import { Controller } from "stimulus";

export default class extends Controller {
  openMessage() {
    if (window.Intercom) {
      Intercom('showNewMessage');
    } else {
      console.debug('Intercom', 'showNewMessage');
    }
  }
}
